import React, { useState, useContext } from "react";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import Checkbox from "@mui/material/Checkbox";
import UserService from "../../services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import usePlandactionsTable from "./usePlandactionsTable.js";
import SubmitButton from "components/CustomButtons/SubmitButton";

import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  formControl: {
    margin: '24px',
  },
}));

function UploadDialog(props) {
  const classes = useStyles();
  const [state, setState] = useState({
    electricite: true,
    gaz: false,
    cvc: false,
    prise: false,
    eau: false,
  });
  const { electricite, gaz, cvc, prise, eau } = state;

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const error =
    [electricite, gaz, cvc, prise, eau].filter((v) => v).length !== 2;
  const { refetch } = usePlandactionsTable();
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal } = props;

  const [newDocumentsInfo, setNewDocumentsInfo] = useState({
    documents: [],
  });
  console.log("newDocumentsInfo", newDocumentsInfo);

  const updateUploadedFiles = (files) =>
    setNewDocumentsInfo({ ...newDocumentsInfo, documents: files });

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("handleSubmit called***************");

    //J'ai combien de fichiers?
    let size = newDocumentsInfo.documents.length;
    console.log(size);
    let sent = 0;
    let errors = 0;
    for (const [index, value] of newDocumentsInfo.documents.entries()) {
      const formData = new FormData();
      // we append each element to the form
      formData.append("files[]", newDocumentsInfo.documents[index]);
      console.log(formData);
      console.log(newDocumentsInfo.documents);
      axios
        .post(
          `https://demo.avob.com/avobbesnetwork/app/memv2/fileupload?app=MEM&idgroup=${chartIdGroup}&type=GED`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          console.log("axios response", res);
          sent = sent + 1;
          if (sent + errors == size) {
            console.log("tout envoyé");
            //closeModal();
            refetch();
            //window.location.reload();
          } else {
            console.log("pas encore");
          }
          //Si nombre de réponse reçues = nombre de fichiers
        })
        .catch((err) => {
          console.log("err file", err);
          errors++;
          if (sent + errors == size) {
            console.log("tout envoyé");
          } else {
            alert("documents non envoyé");
          }
        });
    }
  };

  console.log(handleSubmit);

  return (
    <div style={{ minWidth: "400px" }}>
      <FormControl component="fieldset" className={classes.formControl}>
        <FormLabel component="legend">Type d'énergie</FormLabel>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={electricite}
                onChange={handleChange}
                name="electricite"
              />
            }
            label="Electricité"
          />
          <FormControlLabel
            control={
              <Checkbox checked={gaz} onChange={handleChange} name="gaz" />
            }
            label="Gaz"
          />
          <FormControlLabel
            control={
              <Checkbox checked={cvc} onChange={handleChange} name="cvc" />
            }
            label="CVC"
          />
          <FormControlLabel
            control={
              <Checkbox checked={prise} onChange={handleChange} name="prise" />
            }
            label="Prise de courant"
          />
          <FormControlLabel
            control={
              <Checkbox checked={eau} onChange={handleChange} name="eau" />
            }
            label="Eau"
          />
        </FormGroup>
        <FormHelperText>Be careful</FormHelperText>
      </FormControl>
      <SubmitButton handleSubmit={handleSubmit}>Appliquer</SubmitButton>
    </div>
  );
}

export default UploadDialog;
